import styled from 'styled-components';
import BaseCalendarIcon from '#/shared/components/GeneratedIcons/trimet/Calendar';
import DynamicWidthInput from '#/shared/components/DynamicWidthInput';
import { focusCssRule } from '#/shared/css/focus';

export const DatePickerContainer = styled.div`
  width: 200px;
  color: ${props => props.theme.dropDownText};
`;

export const DateFieldContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${props => props.theme.dropDownBg};
  box-shadow: ${props =>
    props.popperVisible ? props.theme.dropDownInputShadow : 'none'};
  padding-bottom: 5px;
  width: 100%;
`;

export const DateInput = styled(DynamicWidthInput)`
  background-color: transparent;
  border: none;
  color: inherit;
  font-family: inherit;
  font-size: inherit;
`;

export const CalendarIcon = styled(BaseCalendarIcon)`
  height: 1.15em;
  width: 1.15em;
`;

export const PopperWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const PopperContainer = styled.div`
  position: absolute;
  left: 50%;
  transform: translate(-50%, -4px);
  min-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${props => props.theme.dropDownContentBg};
  border-radius: ${props => props.theme.dropDownContentRadius};
  border: 1px solid ${props => props.theme.dropDownBorder};
  box-shadow: ${props => props.theme.dropDownContentShadow};

  & .rdp {
    --rdp-accent-color: ${({ theme }) => theme.dropDownOptionSelected};
    --rdp-selected-color: ${({ theme }) => theme.dropDownTextSelected};
    --rdp-background-color: ${({ theme }) => theme.dropDownOptionSelectedHover};
    --rdp-outline-selected: transparent;
    --rdp-outline: transparent;

    color: ${({ theme }) => theme.dropDownText};
    margin: 0;
    border-radius: ${({ theme }) => theme.dropDownContentRadius};
    padding: 5px 8px;
    font-size: 0.7em;

    & .rdp-nav_button {
      ${focusCssRule({ type: 'default' })}

      &:focus-visible {
        background: transparent;
      }
    }

    & .rdp-day {
      ${focusCssRule({ type: 'default' })}

      &.rdp-day_selected {
        &.rdp-button:focus-visible:not([disabled]) {
          background-color: ${({ theme }) => theme.dropDownOptionSelected};
        }
      }

      &:focus-visible:not(.rdp-day_selected) {
        background-color: transparent;
      }
      &:focus-visible:not(.rdp-day_selected):hover {
        background-color: ${({ theme }) => theme.dropDownOptionSelectedHover};
      }
    }
  }
`;
